import '@babylonjs/core/Audio/audioSceneComponent';
import '@babylonjs/core/Audio/audioEngine';
import { Sound } from '@babylonjs/core/Audio/sound';
import { Scene } from '@babylonjs/core/scene';
import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import find from 'lodash/find';
import remove from 'lodash/remove';

import fire21 from 'url:../../docs/assets/sounds/Fire-21.mp3';
import fire4 from 'url:../../docs/assets/sounds/Fire-4.mp3';
import fire18 from 'url:../../docs/assets/sounds/Fire-18.mp3';
import fire9 from 'url:../../docs/assets/sounds/Fire-9.mp3';
import fire10 from 'url:../../docs/assets/sounds/Fire-10.mp3';
import fire22 from 'url:../../docs/assets/sounds/Fire-22.mp3';
import fire23 from 'url:../../docs/assets/sounds/Fire-23.mp3';

interface SoundInterface {
    name: 
    'sunChange' | 
    'nebulaChange' | 
    'play' |
    'dead' |
    'catchPlanet' |
    'catchDust' |
    'absorb' |
    'explodeStart' |
    'explodeEnd' |
    'levelUp' |
    'levelDown' |
    'accelerate'
    ;
    volume: number;
    needClone: boolean;
    loop: boolean;
    spatial: boolean;
    path: string,
}

let soundList: SoundInterface[] = [
    { name: 'nebulaChange', volume: 0.8, needClone: false, loop: false, spatial: false, path: fire9 },
    { name: 'sunChange', volume: 0.3, needClone: false, loop: false, spatial: false, path: fire21 },
    { name: 'play', volume: 1, needClone: false, loop: false, spatial: false, path: fire10 },
    { name: 'dead', volume: 0.6, needClone: false, loop: false, spatial: false, path: fire10 },
    { name: 'catchPlanet', volume: 0.8, needClone: true, loop: false, spatial: false, path: fire23 },
    // { name: 'catchDust', volume: 0.06, needClone: true, loop: false, spatial: false, path: fire6 },
    { name: 'absorb', volume: 0.5, needClone: true, loop: true, spatial: true, path: fire22 },
    // { name: 'explodeStart', volume: 1, needClone: true, loop: false, spatial: true, path: fire6 },
    { name: 'explodeEnd', volume: 0.4, needClone: true, loop: false, spatial: true, path: fire4 },
    // { name: 'levelDown', volume: 0.5, needClone: false, loop: false, spatial: false, path: fire1 },
    // { name: 'levelUp', volume: 0.5, needClone: false, loop: false, spatial: false, path: fire1 },
    { name: 'accelerate', volume: 0.6, needClone: true, loop: false, spatial: true, path: fire18 },
];

export class SoundManager {

    Sounds: any = {};
    mainsound: any;
    on = true;

    scene: Scene;

    constructor(scene: Scene) {
        this.scene = scene;

        window.addEventListener('blur', () => {
            this.stopAllSounds();
        });
    }
    
    load() {
        // this.mainsound = new Sound('mainsound', asseturl + "sound/wazana.mp3", scene);
        for (let i = 0; i < soundList.length; i++) {
            const sound = soundList[i];
            const { name, path, loop, spatial } = sound;
            //! BJS Sounds does not work if there is a query in the path
            const pathWithoutQuery = path.split('?')[0];
            this.Sounds[name] = new Sound(name, pathWithoutQuery, this.scene, null, {
                loop,
                // spatialSound: spatial,
            });
            // this.Sounds[name].on
        }
    }

    setOn() {
        this.on = true;
    }

    setOff() {
        this.on = false;
        this.stopAllSounds();
    }

    play(sound: SoundInterface['name']): Sound | null {
        if (!this.on) return null;
        return this.start(sound, 1);
    }

    playMesh(sound: SoundInterface['name'], mesh: TransformNode, volume ? : number): Sound | null {
        if (!this.on) return null;
        let soundO = this.start(sound, volume || 1, mesh);
        if (mesh && soundO) {
            if (mesh.position) {
                soundO.attachToMesh(mesh);
            }
        }
        return soundO;
    }

    fadeIn(sound: SoundInterface['name'], time ? : number) {
        if (this.Sounds[sound] == undefined) return;
        let soundParam = find(soundList, (s) => { return s.name == sound }) as SoundInterface;
        this.Sounds[sound].play();
        this.Sounds[sound].setVolume(soundParam.volume, time || 2)
    }

    fadeOut(sound: SoundInterface['name'], time ? : number) {
        if (this.Sounds[sound] == undefined) return;
        this.Sounds[sound].setVolume(0, time || 2);
        setTimeout(() => {
            this.Sounds[sound].stop();
        }, (time || 2) * 1000);
    }

    soundsPlaying: Sound[] = [];
    start(sound: SoundInterface['name'], volume: number, mesh?: TransformNode): Sound | null {
        let soundParam = find(soundList, (s) => { return s.name == sound }) as SoundInterface;
        let soundO;
        if (soundParam.needClone) soundO = this.Sounds[sound].clone();
        else soundO = this.Sounds[sound];
        soundO.setVolume(volume * soundParam.volume);
        soundO.play();
        this.soundsPlaying.push(soundO);
        return soundO;
    }

    stop(sound: SoundInterface['name'], soundO: Sound) {
        soundO.stop();
        remove(this.soundsPlaying, (s) => { return s == soundO });
        let soundParam = find(soundList, (s) => { return s.name == sound });
        if (soundParam.needClone) {
            soundO.dispose();
        }
    }

    stopAllSounds() {
        for (let i = 0; i < this.soundsPlaying.length; i++) {
            const soundO = this.soundsPlaying[i];
            soundO.stop();
        }
        this.soundsPlaying = [];
    }
}
